import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-i18nify';
import LoadingSpinner from '../../LoadingSpinner';

class InfoSolutionsReferrals extends Component {
  render() {
    const { referrals } = this.props;

    return referrals.allReferralsLoading ? (
      <LoadingSpinner size="small" />
    ) : (
      <section>
        {referrals && !referrals.allReferralsError && referrals.allReferrals && referrals.allReferrals.redirectUrl ? (
          <iframe src={referrals.allReferrals.redirectUrl} frameBorder="0" title="Info Solutions"></iframe>
        ) : (
          <Translate value="patient_view.referrals.error" />
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    referrals: state.referrals
  };
};

export default connect(mapStateToProps)(InfoSolutionsReferrals);
